export enum Variant {
  DEFAULT,
  DARK
}

export enum Size {
  DEFAULT,
  LARGE
}
